export default "__VITE_ASSET__0accf1c5__"